import { storeCreator } from '@/utils/store/store.utils';

interface State {
  collapseSignal: number;
  expandSignal: number;
  collapseAll: () => void;
  expandAll: () => void;
}

export const useModulesCollapseStore = storeCreator<State>((set) => ({
  collapseSignal: 0,
  expandSignal: 0,
  collapseAll: () => set((state) => ({ collapseSignal: state.collapseSignal + 1 })),
  expandAll: () => set((state) => ({ expandSignal: state.expandSignal + 1 })),
}));

export default useModulesCollapseStore;
